import BaseApi from './base/BaseApi';

export default class CrmLeadApi extends BaseApi {
  static entityName = 'crm_leads';
}
